import classNames from 'classnames';
import Modal from 'components/containers/Modal/Modal';
import IconButton from 'components/generics/buttons/IconButton';
import Typography from 'components/generics/texts/Typography';
import React, { HTMLAttributes, PropsWithChildren } from 'react';
import classes from './index.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  childrenContainerClassName?: string;
}

const BaseLandaFinancingModal = ({
  isOpen,
  onClose,
  title,
  children,
  childrenContainerClassName,
  className,
}: PropsWithChildren<Props>) => {
  return (
    <Modal
      className={classNames(classes.container, className)}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className={classes.topContainer}>
        <IconButton
          className={classes.icon}
          onClick={onClose}
          variant="close"
        />
        <Typography className={classes.text}>{title}</Typography>
      </div>
      <div
        className={classNames(
          classes.childrenContainer,
          childrenContainerClassName
        )}
      >
        {children}
      </div>
    </Modal>
  );
};

export default BaseLandaFinancingModal;
